import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {selectSelectedGame} from '../../slices/selected'
import JSZip from "jszip";
import saveAs from "file-saver";
import Button from '../../components/Common/Button';
import AttachmentIcon from '@material-ui/icons/Attachment';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {computeGameDeadline, fileRequestToExtensions, isFollowingGameExpired, sanitizeUrl} from '../../helpers/misc';
import {useHistory} from 'react-router';
import ButtonCircle from '../../components/Common/ButtonCircle';
import {openDialog} from '../../slices/dialog';
import {GameSubmission} from '../../components/Dialog/GameSubmission';
import {selectUser} from '../../slices/profile';
import {useTranslation} from 'react-i18next';
import {gameRequests, ROUTES} from '../../db/models/const';
import {GameSubmissionNoProject} from '../../components/Dialog/GameSubmissionNoProject';
import { whenStudentFollowedRmTimestamp } from '../../helpers/student';

export const StudentFollowGame = () => {
    const game = useSelector(selectSelectedGame);
    const history = useHistory();
    const title = game?.title || "";
    const description = game?.description || "";
    const [request, setRequest] = useState();
    const [extensions, setExtensions] = useState();
    const task = game?.task || "";
    const [attachments, setAttachments] = useState([]);
    const link = sanitizeUrl(game?.link || "");
    const reward = game?.reward || "";
    const [deadline, setDeadline] = useState();
    const user = useSelector(selectUser);
    const attended = (user?.games || []).find(sg => sg?.id === game?.id);
    const [isExpired, setIsExpired] = useState();
    const [showUploadButton, setShowUploadButton] = useState(false);
    const [showReviewButton, setShowReviewButton] = useState(false);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    useEffect(() => {
        if (!game) history.push(ROUTES.ME);

        setAttachments(Object.entries(game?.attachments || {}))

        const request = gameRequests.find(request => request.id === game?.request);
        setRequest(t(request?.label));

        setExtensions(fileRequestToExtensions(game?.request));
    }, [game]);

    useEffect(() => {
        setShowUploadButton(!isExpired && !attended && game?.request !== "external");
        setShowReviewButton(!isExpired && !attended && game?.request === "external");
    }, [game, isExpired, attended]);

    useEffect(() => {
        if (!game || !user) return;

        setIsExpired(isFollowingGameExpired(game, whenStudentFollowedRmTimestamp(user, game.rmId)));
        setDeadline(computeGameDeadline(game, whenStudentFollowedRmTimestamp(user, game.rmId)))
    }, [game, user])

    const onDownloadAttachments = () => {
        const jszip = new JSZip();

        attachments.forEach(att => {
            const name = att[0];
            const url = att[1];

            jszip.file(
                name,
                downloadAttachment(url)
            );
        });

        const gameTitle = title.split(' ').join('_');

        jszip.generateAsync({type: "blob"}).then(content => {
            saveAs(content, `${gameTitle}.zip`);
        });
    }

    const downloadAttachment = url => {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", url, true);
            xhr.responseType = "arraybuffer";
            xhr.onreadystatechange = function (evt) {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        resolve(xhr.response);
                    } else {
                        reject("Error");
                    }
                }
            };
            xhr.send();
        });
    }

    const onUpload = () => {
        dispatch(openDialog({
            Content: GameSubmission,
            title: t("student_submission_title"),
            props: {game},
            closable: true
        }))
    }

    const onReview = () => {
        dispatch(openDialog({
            Content: GameSubmissionNoProject,
            title: t("student_submissionNoProject_title"),
            props: {game},
            closable: true
        }))
    }

    return (
        <div className="studentFollowGame">
            <div className="studentFollowGame__navHeader">
                <ButtonCircle onClick={() => history.goBack()}>
                    <ArrowBackIcon/>
                </ButtonCircle>
                <h2>Games</h2>
            </div>
            <div className="card game">
                <div className="card__header border">
                    <h2>{title}</h2>
                </div>
                <div className="card__content">
                    <div className="item">
                        <label>{t("student_follow_gameDetails_request")}</label>
                        <p>{request}{extensions && " (" + extensions + ")"}</p>
                        {game?.request === "external" && <p>{t("student_follow_gameDetails_request_external")}</p>}
                    </div>
                    <div className="item">
                        <label>{t("student_follow_gameDetails_deadline")}</label>
                        <p>{deadline}</p>
                    </div>
                    <div className="item">
                        <label>{t("student_follow_gameDetails_desc")}</label>
                        <p>{description}</p>
                    </div>
                    <div className="item">
                        <label>{t("student_follow_gameDetails_task")}</label>
                        <p>{task}</p>
                    </div>
                    {reward && <div className="item">
                        <label>{t("student_follow_gameDetails_reward")}</label>
                        <p>{reward}</p>
                    </div>}
                    {link && <div className="item">
                        <label>{t("student_follow_gameDetails_link")}</label>
                        <a className="link" target="_blank" rel="noopener noreferrer" href={sanitizeUrl(link)}>{link}</a>
                    </div>}
                    <div className="item">
                        <label>{t("student_follow_gameDetails_attachments")}</label>
                        <div className="attachments">
                            {attachments.map(e => (
                                <div className="a">
                                    <AttachmentIcon/>
                                    <p key={e[0]}>{t("student_follow_gameDetails_attachment") + " "}{e[0]}</p>
                                </div>
                            ))}
                            {!isExpired && attachments.length > 0 && <Button
                                onClick={() => onDownloadAttachments()}>{t("student_follow_gameDetails_downloadZip")}</Button>}
                        </div>
                    </div>
                </div>
                <div className="card__footer">
                    {showUploadButton &&
                        <Button onClick={() => onUpload()}>{t("student_follow_gameDetails_sendButton")}</Button>}
                    {showReviewButton &&
                        <Button onClick={() => onReview()}>{t("student_follow_gameDetails_reviewButton")}</Button>}
                </div>
            </div>
        </div>
    )
}
